export default "__VITE_ASSET__Bdd9Z8UJ__"